import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaUser, FaBook, FaCalendarCheck, FaBullhorn, FaClipboardList, FaClock } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const StaffDashboard = () => {
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const dashboardItems = [
    { title: 'My Profile', icon: <FaUser size={30} />, link: '/staff/profile', description: 'View and update your personal information.' },
    { title: 'My Courses', icon: <FaBook size={30} />, link: '/staff/courses', description: 'Access your assigned courses and materials.' },
    { title: 'Student Attendance', icon: <FaCalendarCheck size={30} />, link: '/staff/attendance', description: 'Mark and manage student attendance.' },
    { title: 'View Timetable', icon: <FaClock size={30} />, link: '/staff/timetable', description: 'Check your weekly class schedule.' },
    { title: 'Announcements', icon: <FaBullhorn size={30} />, link: '/staff/announcements', description: 'View important announcements from the institution.' },
    { title: 'Leave Application', icon: <FaClipboardList size={30} />, link: '/staff/leave', description: 'Apply for and track your leave requests.' },
  ];

  return (
    <Container fluid className="py-4 px-lg-5 bg-light-subtle min-vh-100">
      <div className="mb-4">
        <h2 className="fw-bolder">Welcome, {user.exName || 'Staff Member'}!</h2>
        <p className="text-muted">Here's a quick overview of your portal.</p>
      </div>
      <Row>
        {dashboardItems.map((item, index) => (
          <Col key={index} md={6} lg={4} className="mb-4">
            <Card as={Link} to={item.link} className="h-100 text-decoration-none shadow-sm dashboard-card">
              <Card.Body className="d-flex align-items-center p-4">
                <div className="dashboard-card-icon me-4">
                  {item.icon}
                </div>
                <div>
                  <Card.Title className="mb-1 fw-bold">{item.title}</Card.Title>
                  <Card.Text className="small text-muted">{item.description}</Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <style>{`
        .dashboard-card { transition: all 0.3s ease; border: 1px solid #e9ecef; color: inherit; }
        .dashboard-card:hover { transform: translateY(-5px); box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important; border-color: var(--primary-color, #3b82f6); }
        .dashboard-card-icon { padding: 1.25rem; background: linear-gradient(135deg, #e0e7ff, #c7d2fe); color: var(--primary-color, #3b82f6); border-radius: 50%; }
      `}</style>
    </Container>
  );
};

export default StaffDashboard;